import { isRedirectToType } from "@circle-react/helpers/paywallCustomizationHelpers";

import { usePaywallCustomizationContext } from "../CheckoutPage/CheckoutDescription/PaywallCustomization/PaywallCustomizationProvider";

export const useIsCountdownRedirectEnabled = () => {
  const { paywallCustomization } = usePaywallCustomizationContext();
  const { enabled: isCountdownEnabled } =
    paywallCustomization?.countdown_properties || {
      enabled: false,
    };

  const countdownProperties = paywallCustomization?.countdown_properties;

  return (
    isCountdownEnabled &&
    isRedirectToType(countdownProperties?.action?.action_type)
  );
};
